import Button from '@mui/material/Button'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'

const ButtonSave = ({ onClick, disabled, children }) => {
    return (
        <Button
            startIcon={
                <AddCircleOutlineOutlinedIcon
                    style={{
                        width: '18px',
                        height: '18px',
                        color: 'white',
                    }}
                />
            }
            variant='contained'
            color='buttonSave'
            sx={{
                backgroundColor: '#0C58AD',
                textTransform: 'uppercase',
                borderRadius: '30px',
                height: '30px',
                fontWeight: 'bold',
                fontSize: '12px',
                marginRight: '10px',
                '&:hover': {
                    backgroundColor: '#09488C',
                },
                '&:disabled': {
                    backgroundColor: '#B0C4DE',
                    color: '#FFFFFF',
                },
            }}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </Button>
    )
}

export default ButtonSave
